/** Eenmalige Ordenen-intro op de Actief-tab (organizeIntro). */
import { useCallback, useEffect, useRef, useState } from 'react';
import { ONBOARDING_HINT_ORGANIZE_INTRO } from '@/constants/onboardingHints';
import { useTier } from '@/features/tier/useTier';
import { markHintSeen } from '@/services/userService';

/**
 * @param {Object} params
 * @param {boolean} params.isActiveTab
 * @param {string | undefined} params.userId
 */
export function useOrganizeIntroHint({ isActiveTab, userId }) {
  const { seenHints, profileLoaded } = useTier();
  const initRef = useRef(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!isActiveTab || !userId || !profileLoaded) {
      return;
    }
    if (initRef.current) {
      return;
    }
    initRef.current = true;
    if (seenHints.includes(ONBOARDING_HINT_ORGANIZE_INTRO)) {
      return;
    }
    setOpen(true);
    void markHintSeen(userId, ONBOARDING_HINT_ORGANIZE_INTRO);
  }, [isActiveTab, userId, profileLoaded, seenHints]);

  const dismiss = useCallback(() => {
    setOpen(false);
  }, []);

  return { showHint: open, dismissHint: dismiss };
}
